import React from "react";
import "../css/returns.scss";

function Returns() {
  return <main id="main" className="main"><div className="shopify-policy__container">
    <div className="shopify-policy__title"><h1>Return policy</h1></div>
    <div className="shopify-policy__body"><div className="rte">
      <p>Last updated: September 14, 2026</p>
      <h2>Contact us first</h2>
      <p>Before returning an item, email <a href="mailto:phase@slayfulpawsco.cloud">phase@slayfulpawsco.cloud</a> with your order number and reason for the request. Unapproved parcels may not be identifiable or accepted.</p>
      <h2>Return eligibility</h2>
      <p>Unless a different period is shown at purchase or required by law, contact us within 14 days of delivery. Items should be unused, complete, and in their original condition and packaging. Proof of purchase is required.</p>
      <h2>Damaged, defective, or incorrect items</h2>
      <p>Report an issue promptly and include clear photos of the item, outer parcel, and shipping label. After review, we may offer a replacement, repair, partial refund, or refund as appropriate.</p>
      <h2>Exceptions</h2>
      <p>Personalized, final-sale, hygiene-sensitive, used, or damaged-after-delivery items may not be returnable except where applicable law requires otherwise. Gift cards and digital items are not returnable.</p>
      <h2>Return shipping and refunds</h2>
      <p>Return instructions and responsibility for postage will be confirmed before shipment. Approved refunds are issued to the original payment method after inspection. Original delivery and import charges are not refundable unless required by law or the return results from our error.</p>
      <h2>Consumer rights</h2>
      <p>This policy does not limit mandatory cancellation, quality, warranty, or refund rights that apply in your location.</p>
      <p>Mail: Forest Inc., 390 Lofton Rd NW, Atlanta, GA 30309 US</p>
    </div></div>
  </div></main>;
}

export default Returns;
